export default __webpack_public_path__ + "hembar-dark.svg";